import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'

interface Props {
  text: string
  maxWidth?: string
  textAlign?: string
  enclosed?: boolean
  size?: string
  variant?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextCard',
  props: {
    text: null,
    maxWidth: null,
    textAlign: null,
    enclosed: { type: Boolean },
    size: null,
    variant: null
  },
  setup(__props: any) {

const props = __props as {
  text: string
  maxWidth?: string
  textAlign?: string
  enclosed?: boolean
  size?: string
  variant?: string
}



// eslint-disable-next-line @typescript-eslint/no-unused-vars
const classes = computed(() => {
  let result = ''
  if (props.textAlign) {
    result += props.textAlign + ' '
  } else {
    result += 'text-center '
  }
  if (props.enclosed) {
    result +=
      'mx-6 px-5 py-10px bg-stone-95 border-solid border-2 border-white rounded-xl'
  }
  switch (props.size) {
    case 'sm':
      result += ' text-bodyXl sm:text-bodyXl xl:text-body2xl'
      break
    case 'lg':
    case undefined:
      result += ' text-bodyXl sm:text-body2xl xl:text-body3xl'
      break
    default:
      result += ' ' + props.size
      break
  }
  switch (props.variant) {
    case 'light':
      result += ' text-white'
      break
    default:
      result += ' text-slateGray'
      break
  }
  return result
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["text-card flex justify-center flex-col", _unref(classes)]),
    style: _normalizeStyle({ maxWidth: props.maxWidth ? props.maxWidth : '650px' }),
    tabindex: "1"
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("h2", null, _toDisplayString(props.text), 1),
    _renderSlot(_ctx.$slots, "postText")
  ], 6))
}
}

})